import { basicsNest } from "./scripts/basics-nest.js";
import { basicsReschedule } from "./scripts/basics-reschedule.js";
import { settingDeadlineUrgency } from "./scripts/setting-deadline-urgency.js";
import { settingMatrixScope } from "./scripts/setting-matrix-scope.js";
import { settingSubtaskRollup } from "./scripts/setting-subtask-rollup.js";
import { themePreview } from "./scripts/theme-preview.js";
import { todayTour } from "./scripts/today-tour.js";
import type { DemoScript } from "./types.js";

/** Every registered ghost-demo script. tools/demo-check discovers scripts from
 *  this record at runtime, so adding one here automatically adds its rot check.
 *  Keys are literal (not computed) so `DemoScriptId` stays a string-literal
 *  union; scripts.test.ts asserts each key equals its script's `id`. */
export const DEMO_SCRIPTS = {
  "basics-reschedule": basicsReschedule,
  "basics-nest": basicsNest,
  "setting-matrix-scope": settingMatrixScope,
  "setting-deadline-urgency": settingDeadlineUrgency,
  "setting-subtask-rollup": settingSubtaskRollup,
  "theme-preview": themePreview,
  "today-tour": todayTour,
} as const satisfies Record<string, DemoScript>;

export type DemoScriptId = keyof typeof DEMO_SCRIPTS;

export function getDemoScript(id: string): DemoScript | null {
  return (DEMO_SCRIPTS as Record<string, DemoScript>)[id] ?? null;
}
